import { IconButton, Typography } from "@mui/material";
import { FaChevronLeft } from "react-icons/fa6";
import { Link } from "react-router-dom";

import noAvatarImage from "../../../imagenes/no_avatar.svg";
import { useTeaching } from "../hooks/useTeaching";

export function Header() {
	const { course, student } = useTeaching();

	if (!course || !student) {
		return;
	}

	const studentName = `${student.firstName} ${student.lastName}`.trim();

	return (
		<div className="header">
			<Link to={`/my-services/${course.courseSlug}/students`}>
				<IconButton className="icon-button">
					<FaChevronLeft />
				</IconButton>
			</Link>

			<img
				src={
					student.profile?.thumbnail || student.profile?.url || noAvatarImage
				}
				className="avatar"
			/>

			<div>
				<Link
					to={`/profile/${student.profile?.profileSlug}`}
					target="_blank"
					className="black-text underline-on-hover-link">
					<Typography className="small-title-text bold">
						{studentName}
					</Typography>
				</Link>
				<Link
					to={`/services/${course.courseSlug}`}
					target="_blank"
					className="black-text underline-on-hover-link">
					<Typography className="normal-text">{course.name}</Typography>
				</Link>
			</div>
		</div>
	);
}
